import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Lines = ({ lines, className = "", delay = 0, as: Tag = "h2" }) => {
  const M = motion[Tag] || motion.h2;
  return (
    <M className={className} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-10%" }}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className="block"
            variants={{ hidden: { y: "110%" }, show: { y: 0 } }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </M>
  );
};

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10%" }}
    transition={{ duration: 1, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <FadeUp className={className}>
    <p className="font-sans text-[11px] md:text-xs uppercase tracking-[0.3em] text-earth flex items-center gap-4">
      <span className="inline-block w-8 h-px bg-earth" />
      {children}
    </p>
  </FadeUp>
);
